import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ModalService } from '../../modal/modal.service';
import { SupportMyTicketsModalComponent } from '../../modals/support-my-tickets-modal/support-my-tickets-modal.component';
import { StoreModalComponent } from '../../store/store-modal/store-modal.component';
import { environment } from '@env/environment';
import { StoreDepositTabsEnum, StoreVariantsEnum } from '@models/store.interface';
import { IconComponent } from '@shared/icon/icon.component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [RouterLink, IconComponent],
})
export class FooterComponent {
  currentYear = new Date().getFullYear();
  cdnBase = environment.cdnBase;

  constructor(private modalService: ModalService) {}

  openDepositModal(tab?: keyof typeof StoreDepositTabsEnum, coinType?: string) {
    const modalData: any = {
      variant: StoreVariantsEnum.deposit,
      tab: tab,
    };

    if (coinType && tab === 'crypto') {
      modalData.coinType = coinType;
    }

    this.modalService.open(StoreModalComponent, modalData, { requiresAuth: true });
  }

  openSupportModal() {
    this.modalService.open(SupportMyTicketsModalComponent, null, { requiresAuth: true });
  }
}
